import React, { Fragment } from "react";
import { UserAccess } from "components/user-access";
import { Breadcrumbs, VerticalLinkGroup } from "components/navigation";
import { Route, Routes, Navigate } from "react-router-dom";
import { PageRestricted } from "pages/errors/page-restricted";
import { LicenceCheckingUsers } from "pages/licence-checking/settings/users/LicenceCheckingUsers";
import { LicenceCheckingGeneral } from "pages/licence-checking/settings/general/LicenceCheckingGeneral";
import { LicenceCheckingAlerts } from "pages/licence-checking/settings/alerts/LicenceCheckingAlerts";
import { LicenceCheckingHistory } from "pages/licence-checking/settings/history/LicenceCheckingHistory";
import { LicenceCheckingCreditHistory } from "pages/licence-checking/settings/credit-history/LicenceCheckingCreditHistory";
import PropTypes from "prop-types";

export function LicenceCheckingSettings({
    breadcrumbs = []
}) {
    let routes = [
        { location: "/licence-checking/settings/user-access", title: "Users" },
        { location: "/licence-checking/settings/general", title: "Settings" },
        { location: "/licence-checking/settings/alerts", title: "Alerts" },
        { location: "/licence-checking/settings/history", title: "History" },
        {
            location: "/licence-checking/settings/credit-history",
            title: "Credit History",
        },
    ];

    return (
        <UserAccess
            perform={["LicenceChecking:Manage"]}
            yes={() => (
                <Fragment>
                    <div className="row">
                        <Breadcrumbs items={breadcrumbs} />

                        <h1>Manage Licence Checking</h1>
                    </div>

                    <div className="layout-cols">
                        <div className="col side-col">
                            <div className="row">
                                <VerticalLinkGroup
                                    links={routes}
                                    exactRouteMatch={false}
                                ></VerticalLinkGroup>
                            </div>
                        </div>
                        <div className="col content-col">
                            <Routes>
                                <Route path="user-access" element={<LicenceCheckingUsers />} />
                                <Route path="general" element={<LicenceCheckingGeneral />} />
                                <Route path="alerts" element={<LicenceCheckingAlerts />} />
                                <Route path="history" element={<LicenceCheckingHistory />} />
                                <Route path="credit-history" element={<LicenceCheckingCreditHistory />} />
                                <Route path="" element={<Navigate to="/licence-checking/settings/user-access" replace />} />
                            </Routes>
                        </div>
                    </div>
                </Fragment>
            )}
            no={() => <PageRestricted />}
        />
    );
}

LicenceCheckingSettings.propTypes = {
    breadcrumbs: PropTypes.array,
};
